import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";

import {
  Row,
  Col,
  CardBody,
  Card,
  Container,
  Label,
  Form,
  FormFeedback,
  Input,
  InputGroup,
  InputGroupText,
} from "reactstrap";

// Redux
import { connect, useSelector, useDispatch } from "react-redux";
import { Link, Navigate, useNavigate } from "react-router-dom";
import withRouter from "components/Common/withRouter";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";
import * as api from "../../constants/api_constants";

// actions
import { loginUser, apiError, validateTokenRequest } from "../../store/actions";

// import images
import logoSm from "../../assets/images/elbert-logo-sm.png";
import logo from "../../assets/images/Elebert-Logo.png";
import crmLoginBanner from "../../assets/images/crm_login_banner.svg";
import secureLocalStorage from "react-secure-storage";
import { hasRolePermission } from "helpers/rolebased_helper";
import background from "../../assets/images/background.svg";
import logo360 from "../../assets/images/360-degrees 1.svg";

const Login = (props) => {
  const error = props?.error?.toString() ?? "";
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [userLogin, setUserLogin] = useState({ view: false });

  const { user } = useSelector((state) => ({
    user: state.Account.user,
  }));

  const handlePasswordView = () => {
    setUserLogin((prev) => ({ ...prev, view: !prev.view }));
  };

  useEffect(() => {
    if (user && user) {
      setUserLogin({
        ...userLogin,
        email: user.email,
        password: user.password,
      });
    }
  }, [user]);

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      email: userLogin.email || "",
      password: userLogin.password || "",
    },
    validationSchema: Yup.object({
      email: Yup.string().required("Please Enter Your Email"),
      password: Yup.string().required("Please Enter Your Password"),
    }),
    onSubmit: async (values) => {
      dispatch(loginUser(values, props.router.navigate));
    },
  });

  useEffect(() => {
    dispatch(apiError(""));
  }, [validation.values]);

  useEffect(() => {
    const token = secureLocalStorage.getItem("token");
    if (token) {
      navigate("/dashboard");
    }
  }, [navigate]);

  document.title = "Login | Elbert";

  return (
    <React.Fragment>
      <div className="account-pages d-flex flex-row h-100">
        <div
          className="px-5 py-4 d-flex flex-column justify-content-between login-banner d-sm-block d-none"
          style={{
            backgroundImage: `url(${background})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center",
            width: "85%",
          }}
        >
          <div className="w-75 h-50 d-flex flex-column justify-content-center align-items-start text-white">
            <h1 className="my-5 flex justify-start">
              Engage <img src={logo360} alt="logo 360" />
            </h1>
            <h1 style={{ color: "white", marginBottom: "20px" }}>
              Power Up Your Day with Engage 360
            </h1>
            <p className="text-white">
              A Smarter Where Customer Relationships Are Not Just Managed, but
              Transformed into Meaningful Connections That Drive Success
            </p>
          </div>
          <div
            className="d-flex flex-column justify-content-center align-items-center"
            style={{
              marginTop: "240px",
            }}
          >
            <p className="text-white">Powered by Elbert Technology</p>
          </div>
        </div>
        <Container className="d-flex flex-column align-items-center justify-content-center">
          <Row className="w-50">
            <Col md={12}>
              <Card className="overflow-hidden p-0 d-flex flex-column gap-8">
                <div className="d-flex flex-column w-full h-50 justify-content-center align-items-center">
                  <img src={logo} alt="logo" className="w-50 pb-3" />
                  <div className="text-center">
                    <h3 className="p-0 m-0 fs-4">Welcome back!!</h3>
                    <p className="p-0 m-0 fs-6">
                      Sign in to access your CRM account
                    </p>
                  </div>
                </div>

                <CardBody>
                  <div className="p-4">
                    <Form
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      }}
                      action="#"
                    >
                      <div className="mb-3">
                        <Label className="form-label" htmlFor="username">
                          Username
                        </Label>
                        <Input
                          name="email"
                          className="form-control"
                          placeholder="Enter Username"
                          type="email"
                          id="username"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.email || ""}
                          invalid={
                            validation.touched.email && validation.errors.email
                              ? true
                              : false
                          }
                        />
                        {validation.touched.email && validation.errors.email ? (
                          <FormFeedback type="invalid">
                            {validation.errors.email}
                          </FormFeedback>
                        ) : null}
                      </div>

                      <div className="mb-3">
                        <Label className="form-label" htmlFor="userpassword">
                          Password
                        </Label>
                        <InputGroup size="sm" className="elbert-search-group">
                          <Input
                            name={"password"}
                            value={validation.values.password || ""}
                            type={userLogin.view ? "text" : "password"}
                            className="form-control"
                            placeholder="Enter Password"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            invalid={
                              validation.touched.password &&
                              validation.errors.password
                                ? true
                                : false
                            }
                          />
                          <InputGroupText onClick={handlePasswordView}>
                            {!userLogin.view ? (
                              <span className="fa fa-eye"></span>
                            ) : (
                              <span className="fa fa-eye-slash"></span>
                            )}
                          </InputGroupText>
                          {validation.touched.password &&
                          validation.errors.password ? (
                            <FormFeedback type="invalid">
                              {validation.errors.password}
                            </FormFeedback>
                          ) : null}
                        </InputGroup>

                        {error ? <p className="text-danger">{error}</p> : null}
                        <div className="mt-2 mb-0 row text-end">
                          <div className="col-12 my-1">
                            <Link
                              to="/forgot-password"
                              className="text-decoration-none"
                            >
                              <i className="mdi mdi-lock me-1"></i> Forgot your
                              password?
                            </Link>
                          </div>
                        </div>
                      </div>

                      <div className="mb-3 row">
                        <div className="text-center">
                          <button
                            className="btn btn-primary w-md waves-effect waves-light"
                            type="submit"
                          >
                            Log In
                          </button>
                        </div>
                      </div>
                    </Form>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  const { error } = state.Login;
  return { error };
};

export default withRouter(
  connect(mapStateToProps, { loginUser, apiError })(Login)
);

Login.propTypes = {
  error: PropTypes.any,
  history: PropTypes.object,
  loginUser: PropTypes.func,
};
